export default [
    'is_being_built',
    'needs_redecoration',
    'normal_repair',
    'eurorepair',
    'built_to_finishing_strokes',
    'design_repair',
    'need_repair'
];
